<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_SalesReport001
 * @created at      :   2025/09/26
 * @created by      :   ANS901 – hainn@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapMutations, mapState, mapActions } from 'vuex';
import store from '@/store';
import APP_SalesReport001_store from '@/views/mobile/app_sales_report/APP_SalesReport001/store';
import AnsPanel from '@/components/ansPanel/index.vue';
import APP_SalesReport002 from '@/views/mobile/app_sales_report/APP_SalesReport002';
import PopupArea from '@/views/popupSearch/popup_area/store';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import helpers from '@/utils/helpers';
/**
 * Define component chat for show page chat
 */
var APP_SalesReport001 = {
    template: template,
    components: {
        AnsPanel,
        APP_SalesReport002,
        PopupArea
    },
    beforeCreate() {
        if (!store.hasModule('APP_SalesReport001')) {
            store.registerModule('APP_SalesReport001', APP_SalesReport001_store);
        }
        if (!store.hasModule('PopupArea')) {
            store.registerModule('PopupArea', PopupArea);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
    },
    mounted() {
        this.setHeader(this.header);
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        this.setHeader();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'APP_SalesReport001',
            rowActive: null,
            showDetail: false,
            isCheckAll: 0,
            countChecked: 0,
            windowWidth: 0,
            type: 1,
            dummyTableData: [
                {
                    is_check: '',
                    client_cd: '10001001',
                    client_nm: '株式会社ムーヴ',
                    reporting_date: '2025/07/29',
                    client_contract: '仙',
                    sales_person: '幸治',
                    sales_note: '無し'
                },
                {
                    is_check: '',
                    client_cd: '10002002',
                    client_nm: '株式会社CRAZYCORPS EAST',
                    reporting_date: '2025/07/28',
                    client_contract: '江口',
                    sales_person: '直宏',
                    sales_note: '無し'
                },
                {
                    is_check: '',
                    client_cd: '10002003',
                    client_nm: '株式会社CRAZYCORPS WEST',
                    reporting_date: '2025/07/27',
                    client_contract: '前田',
                    sales_person: '直宏',
                    sales_note: '無し'
                },
                {
                    is_check: '',
                    client_cd: '10003001',
                    client_nm: '株式会社フード&ムーヴメント　釜焼鳥本舗おやひなや渋谷ハチ公口店',
                    reporting_date: '2025/07/26',
                    client_contract: '石橋',
                    sales_person: '直宏',
                    sales_note: '無し'
                },
                {
                    is_check: '',
                    client_cd: '10151001',
                    client_nm: '株式会社日本アクセス',
                    reporting_date: '2025/07/29',
                    client_contract: '中村 智洋',
                    sales_person: '志保',
                    sales_note: '無し'
                },
                {
                    is_check: '',
                    client_cd: '10161001',
                    client_nm: '株式会社ヒューストンコーポレーション',
                    reporting_date: '2025/07/29',
                    client_contract: '河野',
                    sales_person: '志保',
                    sales_note: '無し'
                }
            ]
        };
    },
    watch: {
        isCheckAll(val) {
            if (val == 1) {
                this.searchData.forEach((item) => {
                    item.is_check = 1;
                });
                this.countChecked = this.searchData.length;
            }
            if (val == 0 && this.countChecked == this.searchData.length) {
                this.searchData.forEach((item) => {
                    item.is_check = 0;
                });
                this.countChecked = 0;
            }
        }
    },
    computed: {
        ...mapState('APP_SalesReport001', ['data', 'options', 'selectOptionKey', 'paginationData', 'searchData']),
        header() {
            const data = {
                title: '営業報告登録',
                topButtons: [
                    {
                        title: {
                            text: '戻る',
                            class: {},
                            style: {}
                        },
                        isShow: true,
                        isDisabled: false,
                        onClick: () => {
                            this.$emit('back');
                        }
                    }
                ]
            };
            return data;
        },
        isMobile() {
            return helpers.checkIfMobile();
        },
        isIpad() {
            return !(this.windowWidth > 768 && this.windowWidth <= 1366);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapActions('PopupArea', ['searchAreaInfo']),
        referDetail() {
            this.showDetail = !this.showDetail;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        referAreaSearch1(index, value) {
            if (value) {
                this.searchAreaInfo({
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.staff_id_start = result.department_cd;
                        } else {
                            this.data.staff_id_start = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.staff_id_start = '';
            }
        },
        getAreaName1(data) {
            console.log(data);
            // this.data.department_name = data;
        },
        referAreaSearch2(index, value) {
            if (value) {
                this.searchAreaInfo({
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.staff_id_end = result.department_cd;
                        } else {
                            this.data.staff_id_end = '';
                            this.data.department_name = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.staff_id_end = '';
            }
        },
        getAreaName2(data) {
            console.log(data);
            // this.data.department_name = data;
        },
        search() {
            this.$store.commit('APP_SalesReport001/setSearchData', this.dummyTableData);
            this.$store.commit('APP_SalesReport001/setPageNavigation', {
                page: 1,
                pageSize: 10,
                totalRows: this.dummyTableData.length
            });
        },
        changeCurrentPage(data) {
            console.log(data);
        },
        checked() {},
        referAreaInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (value) {
                    this.searchAreaInfo({
                        department_cd: value,
                        mode: 1,
                        callback: (response) => {
                            if (response.Data.data.length > 0) {
                                const result = response.Data.data[0];
                                this.data.department_cd = result.department_cd;
                                this.data.department_name = result.department_name;
                            } else {
                                this.data.department_cd = '';
                                this.data.department_name = '';
                            }
                            // refer data form system top
                            const status = this.$route.params.status ?? '';
                            if (status == 23) {
                                this.data.status = 23;
                                this.search();
                            }
                            resolve();
                        },
                        onError: (error) => {
                            console.log(error);
                            reject(error);
                        }
                    });
                } else {
                    this.data.department_cd = '';
                    this.data.department_name = '';
                    resolve();
                }
            });
        },

        getAreaName(data) {
            this.data.department_name = data;
        }
    }
};
export default APP_SalesReport001;
</script>
